import { queryCargo } from '@/adapters/order';
import { notification } from 'antd';

export const openMapUrl = (
  lat1: string,
  lng1: string,
  lat2?: string, // Optional parameter
  lng2?: string, // Optional parameter
) => {
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_GOOGLE_MAP_URL;

  const url =
    lat2 && lng2
      ? `${baseUrl}/dir/${lat1},${lng1}/${lat2},${lng2}`
      : `${baseUrl}/dir/${lat1},${lng1}`;
  return url;
};

export const onOpenMap = (url: string) => {
  window.open(url, '_blank');
};

export const cargoAction = async (
  numberPlate: string,
  lat?: string,
  lng?: string,
) => {
  const cargo = await queryCargo(numberPlate);
  if (cargo.data && cargo?.data[0]?.latitude) {
    const url = openMapUrl(
      cargo?.data[0]?.latitude,
      cargo?.data[0]?.longitude,
      lat,
      lng,
    );
    onOpenMap(url);
  } else {
    notification.warning({
      message: 'ไม่พบรถขนส่ง',
    });
  }
};
